import { render, staticRenderFns } from "./ProductListMobile.vue?vue&type=template&id=171bb1c4&scoped=true&"
import script from "./ProductListMobile.vue?vue&type=script&lang=js&"
export * from "./ProductListMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProductListMobile.vue?vue&type=style&index=0&id=171bb1c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171bb1c4",
  null
  
)

export default component.exports